export default __webpack_public_path__ + "b4bda87e43da42d9c3c57615dfce0d04.png";